import { h } from 'preact';
import { BASE_REGION_CODE, FOCUS_STUDIO_SLUG, UNIVERSAL_STUDIO_SLUG } from 'utils/constants';

import Cancel from 'components/icons/cancel';
import Check from 'components/icons/check';
import ChevronDown from 'components/icons/chevronDown';
import ChevronLeft from 'components/icons/chevronLeft';
import ChevronRight from 'components/icons/chevronRight';
import ChevronUp from 'components/icons/chevronUp';
import Clipboard from 'components/icons/clipboard';
import Clock from 'components/icons/clock';
import Convert from 'components/icons/convert';
import ConvertCircle from 'components/icons/convert-circle';
import Copy from 'components/icons/copy';
import Delete from 'components/icons/delete';
import Desktop from 'components/icons/desktop';
import DotsVertical from 'components/icons/dotsVertical';
import Download from 'components/icons/download';
import Edit from 'components/icons/edit';
import Eye from 'components/icons/eye';
import File from 'components/icons/file';
import Globe from 'components/icons/globe';
import GlobeCancel from 'components/icons/globe-cancel';
import Filter from 'components/icons/filter';
import Grid from 'components/icons/grid';
import Help from 'components/icons/help';
import Home from 'components/icons/home';
import Info from 'components/icons/info';
import Link from 'components/icons/link';
import List from 'components/icons/list';
import MapPin from 'components/icons/map-pin';
import MapPinCancel from 'components/icons/map-pin-cancel';
import Minus from 'components/icons/minus';
import NavDown from 'components/icons/navDown';
import Save from 'components/icons/save';
import Share from 'components/icons/share';
import SidebarCollapse from 'components/icons/sidebarCollapse';
import Mobile from 'components/icons/mobile';
import Plus from 'components/icons/plus';
import Reset from 'components/icons/reset';
import Revert from 'components/icons/revert';
import Rocket from 'components/icons/rocket';
import Settings from 'components/icons/settings';
import Thundr from 'components/icons/thundr';
import Upload from 'components/icons/upload';
import Undo from 'components/icons/undo';
import Redo from 'components/icons/redo';
import Warning from 'components/icons/warning';

export const icons = {
	none: undefined,
	empty: <svg viewBox="0 0 1 1" />,

	cancel: Cancel,
	check: Check,
	'chevron-down': ChevronDown,
	'chevron-left': ChevronLeft,
	'chevron-right': ChevronRight,
	'chevron-up': ChevronUp,
	clipboard: Clipboard,
	clock: Clock,
	convert: Convert,
	'convert-circle': ConvertCircle,
	copy: Copy,
	desktop: Desktop,
	delete: Delete,
	'dots-vertical': DotsVertical,
	download: Download,
	edit: Edit,
	eye: Eye,
	file: File,
	filter: Filter,
	globe: Globe,
	'globe-cancel': GlobeCancel,
	grid: Grid,
	help: Help,
	home: Home,
	info: Info,
	link: Link,
	list: List,
	minus: Minus,
	mobile: Mobile,
	navDown: NavDown,
	plus: Plus,
	'map-pin': MapPin,
	'map-pin-cancel': MapPinCancel,
	redo: Redo,
	reset: Reset,
	revert: Revert,
	rocket: Rocket,
	save: Save,
	settings: Settings,
	share: Share,
	'sidebar-collapse': SidebarCollapse,
	thundr: Thundr,
	undo: Undo,
	upload: Upload,
	warning: Warning,
};

export function getIcon(definition, props) {
	let Icon = definition in icons ? icons[definition] : definition;
	if (typeof Icon === 'function') {
		return <Icon {...props} />;
	}
	return Icon || null;
}

const studioLogos = {
	[UNIVERSAL_STUDIO_SLUG]: `${__IMAGE_ROOT__}/icons/studios/cms-universal-logo-2x.webp`,
	[FOCUS_STUDIO_SLUG]: `${__IMAGE_ROOT__}/icons/studios/cms-focus-logo-2x.webp`,
};
/**
 * Returns the URL of the studio logo image based on the provided studio slug.
 * If the studio slug is not recognized, it defaults to the Universal Studios logo.
 * @param {string} studio - The studio slug (e.g., 'universal-pictures', 'focus-features')
 * @returns {string} URL of the studio logo image
 */
export function getStudioLogo(studio) {
	return studioLogos[studio] || studioLogos[UNIVERSAL_STUDIO_SLUG];
}

const flagpackSpecialNames = { UK: 'GB-UKM', GB: 'GB-UKM' };
/**
 * Returns the URL of the flag image based on the provided country code.
 * If the country code is the base region code, it returns a specific base icon.
 * For other country codes, it uses the Flagpack library to get the corresponding flag image.
 * @param {string} country - The country code (e.g., 'US', 'CA', 'GB', 'UK')
 * @returns {string} URL of the flag image
 */
export function getFlag(countryCode, props) {
	if (countryCode === BASE_REGION_CODE) return <Globe {...props} />;
	countryCode = countryCode.toUpperCase().replaceAll('_', '-').split('-')[0]; // Remove language codes for flag images, e.g. "CA-EN" -> "CA"
	const file = flagpackSpecialNames[countryCode] || countryCode;
	return <img src={`https://cdn.jsdelivr.net/npm/flagpack-core@2.0.0/svg/m/${file}.svg`} {...props} />;
}
